import React,{useEffect,useState} from 'react'
import Sidebar from '../../components/Sidebar'
import Header from '../../components/Header'
import Card from '../../components/Card'
import './style.css'

import ButtonMobileGif from '../../components/ButtonMobileGif'


import api from '../../services/api'

import moment from "moment";

import mailIcon from '../../images/mailIcon2.png'
import userIcon from '../../images/userProfile.png'
import lockIcon from '../../images/lockIcon2.png'
import pixIcon from '../../images/pixIcon2.png'

import bankIcon from '../../images/bankIcon.png'

import cameraIcon from '../../images/cameraIcon.png'
import verifyUser from '../../functions/verifyUser'

import Transactions from '../../components/Transactions'
import InputMasked from '../../components/InputMasked'
import bankIcon2 from '../../images/bankIcon2.png'

import pixIcon2 from '../../images/pixIcon3.png'
import digitalIcon from '../../images/digitalIcon.png'
import phoneIcon from '../../images/phoneIcon.png'
import calendaIcon from '../../images/calendarIcon.png'



import backIcon from '../../images/backIcon.png'
import userProfile from '../../images/userProfile.png'
import profileIcon from '../../images/profileIcon.png'

import mailIcon2 from '../../images/mailIcon2.png'
import lockIcon2 from '../../images/lockIcon2.png'
import calendarIcon from '../../images/calendarIcon.png'


import InputMaskedMobile from '../../components/InputMaskedMobile'

const Profile = () =>{


   
    const [image,setImage] = useState()
    const [name,setName] = useState()

    const [email,setEmail] = useState()
    const [newEmail,setNewEmail] = useState()
    const [newPassword,setNewPassword] = useState()


    const [pixState,setPixState] = useState('none')
    const [pix,setPix] = useState()
    const [codBank,setBank] = useState()

    const [account,setAccount] = useState()
    const [agency,setAgency] = useState()
    const [newPassword2,setNewPassword2] = useState()

    const [passwordError,setPasswordError] = useState()
    const [disableButton,setDisableButton] = useState(false)
    const [cpfFromApi,setCpfFromApi] = useState()

    const [birthFromApi,setBirthFromApi] = useState()
    const [birthFormated,setBirthDateFormated] = useState()
    const [birthDate,setBirthDate] = useState()

    const [phone,setPhone] = useState()
    const [newPicture,setNewPicture] = useState()
    const [newCpf,setNewCpf] = useState()
    const [imageUserAPi,setImageUserApi] = useState()

    const [codBankMobile,setCodBank] = useState()

    const [gender,setGender] = useState()


    /* Css Options  */


    const [tedValue,setTedValue] = useState('block')
    const [pixValue,setPixValue] = useState('none')
    const [button,setButton] = useState()
    const [stylePhoneNumber,setStylePhoneNumber] = useState(true)


    /* Address*/

    const [citys,setCitys] = useState()
    const [citysArray0,setCitysArray0] = useState([])

    const [showSelect,setShowSelect] = useState(false)
    const [searchSelect,setSearchSelect] = useState()



    /* Get Address From Api */

    const [zip,setZip] = useState()
    const [address,setAddress] = useState()
    const [complement,setComplement] = useState()

    const [neighboard,setNeighboard] = useState()
    const [cityFromApi,setCityFromApi] = useState([])

    const [citySelectUser,setCitySelectUser] = useState([])
    const [codeState,setCodeState] = useState()

    const [dataPayment,setDataPayment] = useState([])
    const [imageDesktop,setImageDesktop] = useState()

    /* Get Banks */

    const [nameBankFromApi,setNameBankFromApi] = useState()
    const [codeBankFromApi,setCodeBankFromApi] = useState()

    const [gif,setGif] = useState(false)
    const [imageMobilePreview,setImageMobilePreview] = useState()


    /* Error Message */

    const [nameError,setNameError] = useState()
    const [phoneError,setPhoneError] = useState()
    const [emailError,setEmailError] = useState()

    const [zipError,setZipError] = useState()
    const [addressError,setAddressError] = useState()
    const [complementError,setComplementError] = useState()

    const [cityError,setCityError] = useState()

    const [neighboardError,setNeighboardError] = useState()
    const [stateError,setStateError] = useState()
    const [stateCity,setStateCity] = useState()

    const [citysFromSelect,setCitysFromSelect] = useState([])
    const [changeHeader,setChangeHeader] = useState(false)
    const [imageSeted,setImageSeted] = useState()
    
    const [imageBase64,setImageBase64] = useState()
    const [showCityFromApi,setShowCityFromApi] = useState()
    const [responseVerifyUser,setResponseVerifyUser] = useState()

    /* Rules */

    const [role,setRole] = useState()

    /* Via Cep Data */

    const [cityFromViaCep,setCityFromViaCep] = useState() 
    const [stateFromViaCep,setStateFromViaCep] = useState()

    /* Banks  */

    const [removeOptionsBank,setRemoveOptionsBank] = useState()
    
    
    const banks = 
    [{ "_id": "59ada9772bc5be4a37aaa435", "name": "Banco ABC Brasil S.A.", "febraban": true, "clearing": true, "code": "246", "alias": null }, { "_id": "59ada9772bc5be4a37aaa437", "name": "Banco Agiplan S.A.", "febraban": true, "clearing": true, "code": "121", "alias": null }, { "_id": "59ada9772bc5be4a37aaa438", "name": "Banco Alfa S.A.", "febraban": true, "clearing": true, "code": "025", "alias": null }, { "_id": "59ada9772bc5be4a37aaa436", "name": "Banco ABN AMRO S.A.", "febraban": true, "clearing": true, "code": "075", "alias": null }, { "_id": "59ada9772bc5be4a37aaa43c", "name": "Banco BBM S.A.", "febraban": true, "clearing": true, "code": "107", "alias": null }, { "_id": "59ada9772bc5be4a37aaa439", "name": "Banco Alvorada S.A.", "febraban": true, "clearing": true, "code": "641", "alias": null }, { "_id": "59ada9772bc5be4a37aaa43b", "name": "Banco BANDEPE S.A.", "febraban": true, "clearing": true, "code": "024", "alias": null }, { "_id": "59ada9772bc5be4a37aaa43a", "name": "Banco Andbank (Brasil) S.A.", "febraban": true, "clearing": true, "code": "065", "alias": null }, { "_id": "59ada9772bc5be4a37aaa43d", "name": "Banco BM&FBOVESPA de Serviços de Liquidação e Custódia S.A", "febraban": true, "clearing": true, "code": "096", "alias": null }, { "_id": "59ada9772bc5be4a37aaa441", "name": "Banco Bonsucesso S.A.", "febraban": true, "clearing": true, "code": "218", "alias": null }, { "_id": "59ada9772bc5be4a37aaa443", "name": "Banco Bradesco BBI S.A.", "febraban": true, "clearing": true, "code": "036", "alias": null }, { "_id": "59ada9772bc5be4a37aaa448", "name": "Banco Cacique S.A.", "febraban": true, "clearing": true, "code": "263", "alias": null }, { "_id": "59ada9772bc5be4a37aaa44d", "name": "Banco Cetelem S.A.", "febraban": true, "clearing": true, "code": "739", "alias": null }, { "_id": "59ada9772bc5be4a37aaa452", "name": "Banco Cooperativo do Brasil S.A. - BANCOOB", "febraban": true, "clearing": true, "code": "756", "alias": null }, { "_id": "59ada9772bc5be4a37aaa457", "name": "Banco CSF S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa45c", "name": "Banco de Tokyo-Mitsubishi UFJ Brasil S.A.", "febraban": true, "clearing": true, "code": "456", "alias": null }, { "_id": "59ada9772bc5be4a37aaa461", "name": "Banco do Nordeste do Brasil S.A.", "febraban": true, "clearing": true, "code": "004", "alias": null }, { "_id": "59ada9772bc5be4a37aaa466", "name": "Banco Ford S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa46b", "name": "Banco INBURSA de Investimentos S.A.", "febraban": true, "clearing": true, "code": "012", "alias": null }, { "_id": "59ada9772bc5be4a37aaa470", "name": "Banco Itaú BBA S.A.", "febraban": true, "clearing": true, "code": "184", "alias": null }, { "_id": "59ada9772bc5be4a37aaa475", "name": "Banco J. P. Morgan S.A.", "febraban": true, "clearing": true, "code": "376", "alias": null }, { "_id": "59ada9772bc5be4a37aaa47a", "name": "Banco Mizuho do Brasil S.A.", "febraban": true, "clearing": true, "code": "370", "alias": null }, { "_id": "59ada9772bc5be4a37aaa47f", "name": "Banco PAN S.A.", "febraban": true, "clearing": true, "code": "623", "alias": null }, { "_id": "59ada9772bc5be4a37aaa484", "name": "Banco RCI Brasil S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa489", "name": "Banco Semear S.A.", "febraban": true, "clearing": true, "code": "743", "alias": null }, { "_id": "59ada9772bc5be4a37aaa48e", "name": "Banco Triângulo S.A.", "febraban": true, "clearing": true, "code": "634", "alias": null }, { "_id": "59ada9772bc5be4a37aaa493", "name": "Banco Western Union do Brasil S.A.", "febraban": true, "clearing": true, "code": "119", "alias": null }, { "_id": "59ada9772bc5be4a37aaa498", "name": "BBN Banco Brasileiro de Negócios S.A.", "febraban": true, "clearing": true, "code": "081", "alias": null }, { "_id": "59ada9772bc5be4a37aaa49d", "name": "BRB - Banco de Brasília S.A.", "febraban": true, "clearing": true, "code": "070", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a2", "name": "Goldman Sachs do Brasil Banco Múltiplo S.A.", "febraban": true, "clearing": true, "code": "064", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a7", "name": "Itaú Unibanco S.A.", "febraban": true, "clearing": true, "code": "341", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4ac", "name": "Scania Banco S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa442", "name": "Banco Bradescard S.A.", "febraban": true, "clearing": true, "code": "063", "alias": null }, { "_id": "59ada9772bc5be4a37aaa447", "name": "Banco BTG Pactual S.A.", "febraban": true, "clearing": true, "code": "208", "alias": null }, { "_id": "59ada9772bc5be4a37aaa44c", "name": "Banco CBSS S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa451", "name": "Banco Confidence de Câmbio S.A.", "febraban": true, "clearing": true, "code": "095", "alias": null }, { "_id": "59ada9772bc5be4a37aaa456", "name": "Banco Crefisa S.A.", "febraban": true, "clearing": true, "code": "069", "alias": null }, { "_id": "59ada9772bc5be4a37aaa45b", "name": "Banco de Lage Landen Brasil S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa460", "name": "Banco do Estado do Rio Grande do Sul S.A.", "febraban": true, "clearing": true, "code": "041", "alias": null }, { "_id": "59ada9772bc5be4a37aaa465", "name": "Banco Finaxis S.A.", "febraban": true, "clearing": true, "code": "094", "alias": null }, { "_id": "59ada9772bc5be4a37aaa46a", "name": "Banco IBM S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa46f", "name": "Banco Investcred Unibanco S.A.", "febraban": true, "clearing": true, "code": "249", "alias": null }, { "_id": "59ada9772bc5be4a37aaa474", "name": "Banco Itaucard S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa479", "name": "Banco Mercantil do Brasil S.A.", "febraban": true, "clearing": true, "code": "389", "alias": null }, { "_id": "59ada9772bc5be4a37aaa47e", "name": "Banco Original S.A.", "febraban": true, "clearing": true, "code": "212", "alias": null }, { "_id": "59ada9772bc5be4a37aaa483", "name": "Banco Rabobank International Brasil S.A.", "febraban": true, "clearing": true, "code": "747", "alias": null }, { "_id": "59ada9772bc5be4a37aaa488", "name": "Banco Santander (Brasil) S.A.", "febraban": true, "clearing": true, "code": "033", "alias": null }, { "_id": "59ada9772bc5be4a37aaa48d", "name": "Banco Toyota do Brasil S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa492", "name": "Banco VR S.A.", "febraban": true, "clearing": true, "code": "610", "alias": null }, { "_id": "59ada9772bc5be4a37aaa497", "name": "Bank of America Merrill Lynch Banco Múltiplo S.A.", "febraban": true, "clearing": true, "code": "755", "alias": null }, { "_id": "59ada9772bc5be4a37aaa49c", "name": "Brasil Plural S.A. - Banco Múltiplo", "febraban": true, "clearing": true, "code": "125", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a1", "name": "Deutsche Bank S.A. - Banco Alemão", "febraban": true, "clearing": true, "code": "487", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a6", "name": "Itaú Unibanco Holding S.A.", "febraban": true, "clearing": true, "code": "652", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4ab", "name": "Paraná Banco S.A.", "febraban": true, "clearing": true, "code": "254", "alias": null }, { "_id": "59ada9772bc5be4a37aaa43f", "name": "Banco BNP Paribas Brasil S.A.", "febraban": true, "clearing": true, "code": "752", "alias": null }, { "_id": "59ada9772bc5be4a37aaa444", "name": "Banco Bradesco Cartões S.A.", "febraban": true, "clearing": true, "code": "204", "alias": null }, { "_id": "59ada9772bc5be4a37aaa449", "name": "Banco Caixa Geral - Brasil S.A.", "febraban": true, "clearing": true, "code": "473", "alias": null }, { "_id": "59ada9772bc5be4a37aaa440", "name": "Banco Boavista Interatlântico S.A.", "febraban": true, "clearing": true, "code": "248", "alias": null }, { "_id": "59ada9772bc5be4a37aaa43e", "name": "Banco BMG S.A.", "febraban": true, "clearing": true, "code": "318", "alias": null }, { "_id": "59ada9772bc5be4a37aaa445", "name": "Banco Bradesco Financiamentos S.A.", "febraban": true, "clearing": true, "code": "394", "alias": null }, { "_id": "59ada9772bc5be4a37aaa446", "name": "Banco Bradesco S.A.", "febraban": true, "clearing": true, "code": "237", "alias": null }, { "_id": "59ada9772bc5be4a37aaa44a", "name": "Banco Cargill S.A.", "febraban": true, "clearing": true, "code": "040", "alias": null }, { "_id": "59ada9772bc5be4a37aaa44b", "name": "Banco Caterpillar S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa44f", "name": "Banco Citibank S.A.", "febraban": true, "clearing": true, "code": "745", "alias": null }, { "_id": "59ada9772bc5be4a37aaa44e", "name": "Banco Cifra S.A.", "febraban": true, "clearing": true, "code": "233", "alias": null }, { "_id": "59ada9772bc5be4a37aaa450", "name": "Banco CNH Industrial Capital S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa454", "name": "Banco Credit Agricole Brasil S.A.", "febraban": true, "clearing": true, "code": "222", "alias": null }, { "_id": "59ada9772bc5be4a37aaa453", "name": "Banco Cooperativo Sicredi S.A.", "febraban": true, "clearing": true, "code": "748", "alias": null }, { "_id": "59ada9772bc5be4a37aaa455", "name": "Banco Credit Suisse (Brasil) S.A.", "febraban": true, "clearing": true, "code": "505", "alias": null }, { "_id": "59ada9772bc5be4a37aaa459", "name": "Banco da China Brasil S.A.", "febraban": true, "clearing": true, "code": "083", "alias": null }, { "_id": "59ada9772bc5be4a37aaa458", "name": "Banco da Amazônia S.A.", "febraban": true, "clearing": true, "code": "003", "alias": null }, { "_id": "59ada9772bc5be4a37aaa45a", "name": "Banco Daycoval S.A.", "febraban": true, "clearing": true, "code": "707", "alias": null }, { "_id": "59ada9772bc5be4a37aaa45e", "name": "Banco do Estado de Sergipe S.A.", "febraban": true, "clearing": true, "code": "047", "alias": null }, { "_id": "59ada9772bc5be4a37aaa45d", "name": "Banco do Brasil S.A.", "febraban": true, "clearing": true, "code": "001", "alias": null }, { "_id": "59ada9772bc5be4a37aaa45f", "name": "Banco do Estado do Pará S.A.", "febraban": true, "clearing": true, "code": "037", "alias": null }, { "_id": "59ada9772bc5be4a37aaa463", "name": "Banco Fibra S.A.", "febraban": true, "clearing": true, "code": "224", "alias": null }, { "_id": "59ada9772bc5be4a37aaa462", "name": "Banco Fator S.A.", "febraban": true, "clearing": true, "code": "265", "alias": null }, { "_id": "59ada9772bc5be4a37aaa464", "name": "Banco Fidis S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa468", "name": "Banco Guanabara S.A.", "febraban": true, "clearing": true, "code": "612", "alias": null }, { "_id": "59ada9772bc5be4a37aaa467", "name": "Banco GMAC S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa469", "name": "Banco Honda S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa46d", "name": "Banco Indusval S.A.", "febraban": true, "clearing": true, "code": "653", "alias": null }, { "_id": "59ada9772bc5be4a37aaa46c", "name": "Banco Industrial do Brasil S.A.", "febraban": true, "clearing": true, "code": "604", "alias": null }, { "_id": "59ada9772bc5be4a37aaa46e", "name": "Banco Intermedium S.A.", "febraban": true, "clearing": true, "code": "077", "alias": null }, { "_id": "59ada9772bc5be4a37aaa472", "name": "Banco Itaú Veículos S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa471", "name": "Banco Itaú Consignado S.A.", "febraban": true, "clearing": true, "code": "029", "alias": null }, { "_id": "59ada9772bc5be4a37aaa473", "name": "Banco ItauBank S.A", "febraban": true, "clearing": true, "code": "479", "alias": null }, { "_id": "59ada9772bc5be4a37aaa477", "name": "Banco John Deere S.A.", "febraban": true, "clearing": true, "code": "217", "alias": null }, { "_id": "59ada9772bc5be4a37aaa476", "name": "Banco J. Safra S.A.", "febraban": true, "clearing": true, "code": "074", "alias": null }, { "_id": "59ada9772bc5be4a37aaa478", "name": "Banco Luso Brasileiro S.A.", "febraban": true, "clearing": true, "code": "600", "alias": null }, { "_id": "59ada9772bc5be4a37aaa47c", "name": "Banco Neon S.A.", "febraban": true, "clearing": true, "code": "735", "alias": null }, { "_id": "59ada9772bc5be4a37aaa47b", "name": "Banco Modal S.A.", "febraban": true, "clearing": true, "code": "746", "alias": null }, { "_id": "59ada9772bc5be4a37aaa47d", "name": "Banco Olé Bonsucesso Consignado S.A.", "febraban": true, "clearing": true, "code": "169", "alias": null }, { "_id": "59ada9772bc5be4a37aaa481", "name": "Banco Pine S.A.", "febraban": true, "clearing": true, "code": "643", "alias": null }, { "_id": "59ada9772bc5be4a37aaa480", "name": "Banco Paulista S.A.", "febraban": true, "clearing": true, "code": "611", "alias": null }, { "_id": "59ada9772bc5be4a37aaa482", "name": "Banco PSA Finance Brasil S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa486", "name": "Banco Rodobens S.A.", "febraban": true, "clearing": true, "code": "120", "alias": null }, { "_id": "59ada9772bc5be4a37aaa485", "name": "Banco Rendimento S.A.", "febraban": true, "clearing": true, "code": "633", "alias": null }, { "_id": "59ada9772bc5be4a37aaa487", "name": "Banco Safra S.A.", "febraban": true, "clearing": true, "code": "422", "alias": null }, { "_id": "59ada9772bc5be4a37aaa48b", "name": "Banco Sumitomo Mitsui Brasileiro S.A.", "febraban": true, "clearing": true, "code": "464", "alias": null }, { "_id": "59ada9772bc5be4a37aaa48a", "name": "Banco Société Générale Brasil S.A.", "febraban": true, "clearing": true, "code": "366", "alias": null }, { "_id": "59ada9772bc5be4a37aaa48c", "name": "Banco Topázio S.A.", "febraban": true, "clearing": true, "code": "082", "alias": null }, { "_id": "59ada9772bc5be4a37aaa490", "name": "Banco Volvo Brasil S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa48f", "name": "Banco Volkswagen S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa491", "name": "Banco Votorantim S.A.", "febraban": true, "clearing": true, "code": "655", "alias": null }, { "_id": "59ada9772bc5be4a37aaa495", "name": "BANESTES S.A. Banco do Estado do Espírito Santo", "febraban": true, "clearing": true, "code": "021", "alias": null }, { "_id": "59ada9772bc5be4a37aaa494", "name": "Banco Yamaha Motor do Brasil S.A.", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa496", "name": "Banif-Banco Internacional do Funchal (Brasil)S.A.", "febraban": true, "clearing": true, "code": "719", "alias": null }, { "_id": "59ada9772bc5be4a37aaa49a", "name": "BEXS Banco de Câmbio S.A.", "febraban": true, "clearing": true, "code": "144", "alias": null }, { "_id": "59ada9772bc5be4a37aaa499", "name": "BCV - Banco de Crédito e Varejo S.A.", "febraban": true, "clearing": true, "code": "250", "alias": null }, { "_id": "59ada9772bc5be4a37aaa49b", "name": "BNY Mellon Banco S.A.", "febraban": true, "clearing": true, "code": "017", "alias": null }, { "_id": "59ada9772bc5be4a37aaa49f", "name": "China Construction Bank (Brasil) Banco Múltiplo S.A.", "febraban": true, "clearing": true, "code": "320", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a0", "name": "Citibank N.A.", "febraban": true, "clearing": true, "code": "477", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a4", "name": "HSBC Brasil S.A. - Banco de Investimento", "febraban": true, "clearing": false, "code": null, "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a3", "name": "Hipercard Banco Múltiplo S.A.", "febraban": true, "clearing": true, "code": "062", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a5", "name": "ING Bank N.V.", "febraban": true, "clearing": true, "code": "492", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a9", "name": "Kirton Bank S.A. - Banco Múltiplo", "febraban": true, "clearing": true, "code": "399", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4a8", "name": "JPMorgan Chase Bank, National Association", "febraban": true, "clearing": true, "code": "488", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4aa", "name": "MS Bank S.A. Banco de Câmbio", "febraban": true, "clearing": true, "code": "128", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4ae", "name": "Standard Chartered Bank (Brasil) S/A–Bco Invest.", "febraban": true, "clearing": true, "code": "118", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4ad", "name": "Scotiabank Brasil S.A. Banco Múltiplo", "febraban": true, "clearing": true, "code": "751", "alias": null }, { "_id": "59ada9772bc5be4a37aaa4af", "name": "UBS Brasil Banco de Investimento S.A.", "febraban": true, "clearing": true, "code": "129", "alias": null }, { "_id": "59ada9772bc5be4a37aaa49e", "name": "Caixa Econômica Federal", "febraban": true, "clearing": true, "code": "104", "alias": "CEF - Caixa" } ]


    /* Async Functions  */

    async function getInfoUser(){

        const response = await api.get('/recipient')

        if(response.status != 200){

          return false

        }

        setResponseVerifyUser(response.data.message)

        setRole(response.data.role)

        setImage(response.data.user.imagemBase64)
        setName(response.data.user.name)

        setEmail(response.data.user.email)
        setPhone(response.data.user.contacts.length == 0 ? '' :response.data.user.contacts[0].number )
        setImageUserApi(response.data.user.imagemBase64)

        setCpfFromApi(response.data.user.cpf)
        setImageBase64(response.data.user.imagemBase64)

        if(response.data.user.birth != null){

          setBirthFromApi(response.data.user.birth)


        }else{

          setBirthFromApi('')

        }


        setAccount(response.data.account)
        setAgency(response.data.agency)
        setGender(response.data.user.gender)

        setPix(response.data.pix)

        if(response.data.addresses.length != 0){

          
        setZip(response.data.addresses[0].zip)
        setAddress(response.data.addresses[0].address)
        setComplement(response.data.addresses[0].complement)

        setNeighboard(response.data.addresses[0].neighborhood)
        setCityFromApi({nameCity:response.data.addresses[0].city.city,idCity:response.data.addresses[0].city.id})
        setCodeState(response.data.addresses[0].city.state.state)

        }else{

          setZip('')
          setAddress('')
          setComplement('')
  
          setNeighboard('')
          setCityFromApi({nameCity:''.city,idCity:''})
          setCodeState('')
        }

        setNameBankFromApi(response.data.bank.name)
        setCodeBankFromApi(response.data.bank.code)



        if(response.data.pix != undefined){
          setPixState(true)
          setPixValue('block')

          setTedValue('none')


        }

        if(response.data.pix == undefined){

          setPixState('none')
          setPixValue('block')
        }



    }
    async function changeData(){

    /* This code snippet validates all fields */
    
    if(name != undefined){
    if(name.length == 0){
    setNameError('Informe um nome')
    }
    if(name.length != 0){
    setNameError('')
    }
    }


    if(phone != undefined){
    if(phone.length == 0 && role != 'atendente'){
    setPhoneError('Informe um telefone')
    }
    if(phone.length != 0){
    setPhoneError('')
    }
    }


    if(citys){
    if(citys.length == 0){
    alert('a')
    }
    }  


    if(email != undefined){
    if(email.length == 0){
    setEmailError('Informe um e-mail')
    }
    if(email.length != 0){
    setEmailError('')
    }
    }


    if(zip != undefined){
    if(zip.length == 0){
    setZipError('Informe um CEP')
    }
    if(zip.length != 0){
    setZipError('')
    }
    }


    if(address != undefined){
    if(address.length == 0){
    setAddressError('Informe um endereço')
    }
    if(address.length != 0){
    setAddressError('')
    }
    }


    if(neighboard != undefined){
    if(neighboard.length == 0){
    setNeighboardError('Informe um bairro')
    }
    if(neighboard.length != 0){
    setNeighboardError('')
    }
    }


    if(role == 'atendente'){
    if(name == '' || email == '' || zip == '' || address == ''  || neighboard == ''){
    setDisableButton(true)
    }else{
    setDisableButton(false)
    }
    return false
    }

    if(name == '' || phone == '' || email == '' || zip == '' || address == ''  || neighboard == ''){
    setDisableButton(true)
    return false
    }else{
    setDisableButton(false)
    }




    setGif(true)

    if(birthDate == undefined  && newPicture == undefined ){

        if(phone == ''){

          let data = {
            name:name,
            email:email,
            mailing:'N',
            gender:gender,
            password:newPassword,
            pix:removeOptionsBank == 'pix' ? '' :pix,
            bank:codBank == undefined ? codeBankFromApi : codBank,
            account:removeOptionsBank == 'ted' ? '':account,
            agency:removeOptionsBank == 'ted' ? '':agency,
            birth:birthFormated,
      
      
      
            address: [
              {
                city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                type: "R",
                address: address,
                complement:complement,
                zip:zip,
                neighborhood: neighboard
      
              }
            
            ]
          }
      
      
      
          let response = await api.put(`/recipient`,data)
          setGif(false)
      
          if (response.status == 200){          
            window.alert('Dados alterados com sucesso!')
            document.location.reload(true);
      
          }
      
          if(response.status !== 200){
      
            window.alert('opss.. algo deu errado tente novamente mais tarde :(')
      
          }
      
      
      
          }
      
          if(phone != ''){
        
            let data = {
              name:name,
              email:email,
              mailing:'N',
              gender:gender,
              password:newPassword,
              pix:removeOptionsBank == 'pix' ? '' :pix,
              bank:codBank == undefined ? codeBankFromApi : codBank,
              account:removeOptionsBank == 'ted' ? '':account,
              agency:removeOptionsBank == 'ted' ? '':agency,
              birth:birthFormated,
        
        
        
              address: [
                {
                  city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                  type: "R",
                  address: address,
                  complement:complement,
                  zip:zip,
                  neighborhood: neighboard
        
                }
              ],
      
              phones: [
                {
                  type: "M",
                  number:phone
                }
              ]
      
            }
      
            let response = await api.put(`/recipient`,data)
            setGif(false)
        
            if (response.status == 200){          
              window.alert('Dados alterados com sucesso!')
              document.location.reload(true);
        
            }
      
        
          }
      
       


      return false

    }

    if(newPicture != undefined && birthDate == undefined  ){

    if(phone == ''){

  
    let response = await api.put(`/recipient`,data)
    setGif(false)

    if (response.status == 200){          
      window.alert('Dados alterados com sucesso!')
      document.location.reload(true);

    }

    if(response.status !== 200){

      window.alert('opss.. algo deu errado tente novamente mais tarde :(')

    }


    let data = {
      image:newPicture == undefined ? image : newPicture,
      name:name,
      email:email,
      mailing:'N',
      gender:gender,
      password:newPassword,
      pix:removeOptionsBank == 'pix' ? '' :pix,
      bank:codBank == undefined ? codeBankFromApi : codBank,
      account:removeOptionsBank == 'ted' ? '':account,
      agency:removeOptionsBank == 'ted' ? '':agency,
      birth:'',



      address: [
        {
          city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
          type: "R",
          address: address,
          complement:complement,
          zip:zip,
          neighborhood: neighboard

        }
      
      ]
    }

    }


    if(phone != ''){
  
      let data = {
        image:newPicture == undefined ? image : newPicture,
        name:name,
        email:email,
        mailing:'N',
        gender:gender,
        password:newPassword,
        pix:removeOptionsBank == 'pix' ? '' :pix,
        bank:codBank == undefined ? codeBankFromApi : codBank,
        account:removeOptionsBank == 'ted' ? '':account,
        agency:removeOptionsBank == 'ted' ? '':agency,
        birth:birthDate,
  
  
  
        address: [
          {
            city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
            type: "R",
            address: address,
            complement:complement,
            zip:zip,
            neighborhood: neighboard
  
          }
        ],

        phones: [
          {
            type: "M",
            number:phone
          }
        ]

      }

      let response = await api.put(`/recipient`,data)
      setGif(false)
  
      if (response.status == 200){          
        window.alert('Dados alterados com sucesso!')
        document.location.reload(true);
  
      }

  
      }


      return false


    }



    if(birthDate != undefined && newPicture == undefined  ){
      if(phone == ''){

        let data = {
          name:name,
          email:email,
          mailing:'N',
          gender:gender,
          password:newPassword,
          pix:removeOptionsBank == 'pix' ? '' :pix,
          bank:codBank == undefined ? codeBankFromApi : codBank,
          account:removeOptionsBank == 'ted' ? '':account,
          agency:removeOptionsBank == 'ted' ? '':agency,
          birth:birthDate,
    
    
    
          address: [
            {
              city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
              type: "R",
              address: address,
              complement:complement,
              zip:zip,
              neighborhood: neighboard
    
            }
          
          ]
        }
    
    
    
        let response = await api.put(`/recipient`,data)
        setGif(false)
    
        if (response.status == 200){          
          window.alert('Dados alterados com sucesso!')
          document.location.reload(true);
    
        }
    
        if(response.status !== 200){
    
          window.alert('opss.. algo deu errado tente novamente mais tarde :(')
    
        }
    
    
    
        }
    
    
        if(phone != ''){
      
          let data = {
            name:name,
            email:email,
            mailing:'N',
            gender:gender,
            password:newPassword,
            pix:removeOptionsBank == 'pix' ? '' :pix,
            bank:codBank == undefined ? codeBankFromApi : codBank,
            account:removeOptionsBank == 'ted' ? '':account,
            agency:removeOptionsBank == 'ted' ? '':agency,
            birth:birthDate,
      
      
      
            address: [
              {
                city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                type: "R",
                address: address,
                complement:complement,
                zip:zip,
                neighborhood: neighboard
      
              }
            ],
    
            phones: [
              {
                type: "M",
                number:phone
              }
            ]
    
          }
    
          let response = await api.put(`/recipient`,data)
          setGif(false)
      
          if (response.status == 200){          
            window.alert('Dados alterados com sucesso!')
            document.location.reload(true);
      
          }
    
      
          }
    

          return false

    }

    if(birthDate != undefined && newPicture != undefined  || image != undefined ){

    if(phone == ''){

    let data = {
      image:newPicture == undefined ? image : newPicture,
      name:name,
      email:email,
      mailing:'N',
      gender:gender,
      password:newPassword,
      pix:removeOptionsBank == 'pix' ? '' :pix,
      bank:codBank == undefined ? codeBankFromApi : codBank,
      account:removeOptionsBank == 'ted' ? '':account,
      agency:removeOptionsBank == 'ted' ? '':agency,
      birth:birthDate,



      address: [
        {
          city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
          type: "R",
          address: address,
          complement:complement,
          zip:zip,
          neighborhood: neighboard

        }
      
      ]
    }



    let response = await api.put(`/recipient`,data)
    setGif(false)

    if (response.status == 200){          
      window.alert('Dados alterados com sucesso!')
      document.location.reload(true);

    }

    if(response.status !== 200){

      window.alert('opss.. algo deu errado tente novamente mais tarde :(')

    }



    }


    if(phone != ''){
      let data = {
        image:newPicture == undefined ? image : newPicture,
        name:name,
        email:email,
        mailing:'N',
        gender:gender,
        password:newPassword,
        pix:removeOptionsBank == 'pix' ? '' :pix,
        bank:codBank == undefined ? codeBankFromApi : codBank,
        account:removeOptionsBank == 'ted' ? '':account,
        agency:removeOptionsBank == 'ted' ? '':agency,
        birth:birthDate,
  
  
  
        address: [
          {
            city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
            type: "R",
            address: address,
            complement:complement,
            zip:zip,
            neighborhood: neighboard
  
          }
        ],

        phones: [
          {
            type: "M",
            number:phone
          }
        ]

      }

      let response = await api.put(`/recipient`,data)
      setGif(false)
  
      if (response.status == 200){          
        window.alert('Dados alterados com sucesso!')
        document.location.reload(true);
  
      }

  
      }
      return false


    }
    }


    async function getDataTransactions(){
      

      const response = await api.get('/payment')

      if(response.status != 200){
        return false
      }
      setDataPayment(response.data)
    }


    async function searchDataCitys(e){


      if(e == ''){
      setStateCity(false)
      return false
      }
  
  
      if(e != undefined){  
      setSearchSelect(e)

      console.log(`searchdatacity ==> ${e}`)
    
      const id_city = await api.get(`/state-city/${e}`)
  
      let array_citys = [] 
      array_citys.push(id_city)  

      setCitys(array_citys)

 
      array_citys.map(item => setCitysArray0(item.data))  
      setShowSelect(true)
      setStateCity('')


      }
    }
    async function changeDataMobile(){
  
        setGif(true)


          /* This code snippet validates all fields */
    
    if(name != undefined){
      if(name.length == 0){
      setNameError('Informe um nome')
      }
      if(name.length != 0){
      setNameError('')
      }
      }
  
  
      if(phone != undefined){
      if(phone.length == 0 && role != 'atendente'){
      setPhoneError('Informe um telefone')
      }
      if(phone.length != 0){
      setPhoneError('')
      }
      }
  
  
      if(citys){
      if(citys.length == 0){
      alert('a')
      }
      }  
  
  
      if(email != undefined){
      if(email.length == 0){
      setEmailError('Informe um e-mail')
      }
      if(email.length != 0){
      setEmailError('')
      }
      }
  
  
      if(zip != undefined){
      if(zip.length == 0){
      setZipError('Informe um CEP')
      }
      if(zip.length != 0){
      setZipError('')
      }
      }
  
  
      if(address != undefined){
      if(address.length == 0){
      setAddressError('Informe um endereço')
      }
      if(address.length != 0){
      setAddressError('')
      }
      }
  
  
      if(neighboard != undefined){
      if(neighboard.length == 0){
      setNeighboardError('Informe um bairro')
      }
      if(neighboard.length != 0){
      setNeighboardError('')
      }
      }
  
  
      if(role == 'atendente'){
      if(name == '' || email == '' || zip == '' || address == ''  || neighboard == ''){
      setGif(false)
      setDisableButton(true)
      }else{
      setDisableButton(false)

      }
      return false
      }
  
      if(name == '' || phone == '' || email == '' || zip == '' || address == ''|| neighboard == ''){
      setGif(false)
      setDisableButton(true)
      return false
      }else{
      setDisableButton(false)

      }


    
        if(birthDate == undefined  && image == undefined ){
    
            if(phone == ''){
    
              let data = {
                name:name,
                email:email,
                mailing:'N',
                gender:gender,
                password:newPassword,
                pix:removeOptionsBank == 'pix' ? '' :pix,
                bank:codBank == undefined ? codeBankFromApi : codBank,
                account:removeOptionsBank == 'ted' ? '':account,
                agency:removeOptionsBank == 'ted' ? '':agency,
                birth:birthFormated,
          
          
          
                address: [
                  {
                    city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                    type: "R",
                    address: address,
                    complement:complement,
                    zip:zip,
                    neighborhood: neighboard
          
                  }
                
                ]
              }
          
          
          
              let response = await api.put(`/recipient`,data)
              setGif(false)
          
              if (response.status == 200){          
                window.alert('Dados alterados com sucesso!')
                document.location.reload(true);
          
              }
          
              if(response.status !== 200){
          
                window.alert('opss.. algo deu errado tente novamente mais tarde :(')
          
              }
          
          
          
              }
          
              if(phone != ''){
            
                let data = {
                  name:name,
                  email:email,
                  mailing:'N',
                  gender:gender,
                  password:newPassword,
                  pix:removeOptionsBank == 'pix' ? '' :pix,
                  bank:codBank == undefined ? codeBankFromApi : codBank,
                  account:removeOptionsBank == 'ted' ? '':account,
                  agency:removeOptionsBank == 'ted' ? '':agency,
                  birth:birthFormated,
            
            
            
                  address: [
                    {
                      city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                      type: "R",
                      address: address,
                      complement:complement,
                      zip:zip,
                      neighborhood: neighboard
            
                    }
                  ],
          
                  phones: [
                    {
                      type: "M",
                      number:phone
                    }
                  ]
          
                }
          
                let response = await api.put(`/recipient`,data)
                setGif(false)
            
                if (response.status == 200){          
                  window.alert('Dados alterados com sucesso!')
                  document.location.reload(true);
            
                }
          
            
              }
          
           
    
    
          return false
    
        }
    
        if(image != undefined && birthDate == undefined  ){
        if(phone == ''){
    
      
        let response = await api.put(`/recipient`,data)
        setGif(false)
    
        if (response.status == 200){          
          window.alert('Dados alterados com sucesso!')
          document.location.reload(true);
    
        }
    
        if(response.status !== 200){
    
          window.alert('opss.. algo deu errado tente novamente mais tarde :(')
    
        }
    
    
        let data = {
          image:image,
          name:name,
          email:email,
          mailing:'N',
          gender:gender,
          password:newPassword,
          pix:removeOptionsBank == 'pix' ? '' :pix,
          bank:codBank == undefined ? codeBankFromApi : codBank,
          account:removeOptionsBank == 'ted' ? '':account,
          agency:removeOptionsBank == 'ted' ? '':agency,
          birth:'',
    
    
    
          address: [
            {
              city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
              type: "R",
              address: address,
              complement:complement,
              zip:zip,
              neighborhood: neighboard
    
            }
          
          ]
        }
    
    
    
    
    
    
        }
    
    
        if(phone != ''){
      
          let data = {
            image:image,
            name:name,
            email:email,
            mailing:'N',
            gender:gender,
            password:newPassword,
            pix:removeOptionsBank == 'pix' ? '' :pix,
            bank:codBank == undefined ? codeBankFromApi : codBank,
            account:removeOptionsBank == 'ted' ? '':account,
            agency:removeOptionsBank == 'ted' ? '':agency,
            birth:birthDate,
      
      
      
            address: [
              {
                city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                type: "R",
                address: address,
                complement:complement,
                zip:zip,
                neighborhood: neighboard
      
              }
            ],
    
            phones: [
              {
                type: "M",
                number:phone
              }
            ]
    
          }
    
          let response = await api.put(`/recipient`,data)
          setGif(false)
      
          if (response.status == 200){          
            window.alert('Dados alterados com sucesso!')
            document.location.reload(true);
      
          }
    
      
          }
    
    
          return false
    
    
        }
    
    
    
        if(birthDate != undefined && image == undefined  ){
    
          if(phone == ''){
    
            let data = {
              name:name,
              email:email,
              mailing:'N',
              gender:gender,
              password:newPassword,
              pix:removeOptionsBank == 'pix' ? '' :pix,
              bank:codBank == undefined ? codeBankFromApi : codBank,
              account:removeOptionsBank == 'ted' ? '':account,
              agency:removeOptionsBank == 'ted' ? '':agency,
              birth:birthDate,
        
        
        
              address: [
                {
                  city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                  type: "R",
                  address: address,
                  complement:complement,
                  zip:zip,
                  neighborhood: neighboard
        
                }
              
              ]
            }
        
        
        
            let response = await api.put(`/recipient`,data)
            setGif(false)
        
            if (response.status == 200){          
              window.alert('Dados alterados com sucesso!')
              document.location.reload(true);
        
            }
        
            if(response.status !== 200){
        
              window.alert('opss.. algo deu errado tente novamente mais tarde :(')
        
            }
        
        
        
            }
        
        
            if(phone != ''){
          
              let data = {
                name:name,
                email:email,
                mailing:'N',
                gender:gender,
                password:newPassword,
                pix:removeOptionsBank == 'pix' ? '' :pix,
                bank:codBank == undefined ? codeBankFromApi : codBank,
                account:removeOptionsBank == 'ted' ? '':account,
                agency:removeOptionsBank == 'ted' ? '':agency,
                birth:birthDate,
          
          
          
                address: [
                  {
                    city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                    type: "R",
                    address: address,
                    complement:complement,
                    zip:zip,
                    neighborhood: neighboard
          
                  }
                ],
        
                phones: [
                  {
                    type: "M",
                    number:phone
                  }
                ]
        
              }
        
              let response = await api.put(`/recipient`,data)
              setGif(false)
          
              if (response.status == 200){          
                window.alert('Dados alterados com sucesso!')
                document.location.reload(true);
          
              }
        
          
              }
        
    
              return false
    
        }
    
        if(birthDate != undefined || image != undefined ){
    
        if(phone == ''){
    
        let data = {
          image:image,
          name:name,
          email:email,
          mailing:'N',
          gender:gender,
          password:newPassword,
          pix:removeOptionsBank == 'pix' ? '' :pix,
          bank:codBank == undefined ? codeBankFromApi : codBank,
          account:removeOptionsBank == 'ted' ? '':account,
          agency:removeOptionsBank == 'ted' ? '':agency,
          birth:birthDate,
    
    
    
          address: [
            {
              city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
              type: "R",
              address: address,
              complement:complement,
              zip:zip,
              neighborhood: neighboard
    
            }
          
          ]
        }
    
    
    
        let response = await api.put(`/recipient`,data)
        setGif(false)
    
        if (response.status == 200){          
          window.alert('Dados alterados com sucesso!')
          document.location.reload(true);
    
        }
    
        if(response.status !== 200){
    
          window.alert('opss.. algo deu errado tente novamente mais tarde :(')
    
        }
    
    
    
        }
    
    
        if(phone != ''){
      
          let data = {
            image:image,
            name:name,
            email:email,
            mailing:'N',
            gender:gender,
            password:newPassword,
            pix:removeOptionsBank == 'pix' ? '' :pix,
            bank:codBank == undefined ? codeBankFromApi : codBank,
            account:removeOptionsBank == 'ted' ? '':account,
            agency:removeOptionsBank == 'ted' ? '':agency,
            birth:birthDate,
      
      
      
            address: [
              {
                city_id:citySelectUser.length == 0 ? cityFromApi.idCity : citySelectUser ,
                type: "R",
                address: address,
                complement:complement,
                zip:zip,
                neighborhood: neighboard
      
              }
            ],
    
            phones: [
              {
                type: "M",
                number:phone
              }
            ]
    
          }
    
          let response = await api.put(`/recipient`,data)
          setGif(false)
      
          if (response.status == 200){          
            window.alert('Dados alterados com sucesso!')
            document.location.reload(true);
      
          }
    
      
          }
          return false
    
    
        }
    }
    async function getCitysFromuser(){
  
        const response = await api.get('/recipient')
  
        const codeState = response.data.addresses[0].city.state.code
  
        const id_city = await api.get(`/state-city/${codeState}`)
  
        let array = []
  
        array.push(id_city)
  
        
        array.map(item => setCitysFromSelect(item.data))
   
    }

    async function getCep(e){


      let zipCodeFromInput = e.target.value

      let zipCodeFormated = zipCodeFromInput.replace('-','')

      fetch(`https://viacep.com.br/ws/${zipCodeFormated}/json/`).then(res => res.json()).then((data) =>{

      console.log(data)
      setShowCityFromApi(true)  

      setCityFromViaCep(data.localidade)
      setStateFromViaCep(data.uf)
      setNeighboard(data.bairro)
      setComplement(data.complemento)
      setAddress(data.logradouro)

      /*This code snippet performs a query to get cities by state */
      searchDataCitys(data.uf)  /* Search city by state  */

      })

    }


    /* Arrow Functions */
  
    const verifyStatePix = (e) =>{

     

      if(e == 'pixSelect'){
        setPixState('block')
        setRemoveOptionsBank('ted')
        
      }

      if(e == 'tedSelect'){
      
        setRemoveOptionsBank('pix')

        setPixState('none')

      }

    }
    const verifyState = (e) =>{

        if(e == 'Pix'){
            setRemoveOptionsBank('ted')
            setPixValue('block')
            setTedValue('none')

        }

        if(e == 'Ted'){
            
            setRemoveOptionsBank('pix')
            setPixValue('none')
            setTedValue('block')
            

        }


    }
    const verifyButton = () =>{

      setButton(true)


    }

    
    const exitApp = () =>{

    localStorage.removeItem('@TOKEN')
    window.location.href="/login"
    }
    const transformImageToBase64Desktop = (e) => {
  // Selecionando o arquivo
  const file = e.target.files[0];

  setImageDesktop(file)

  // Criando um objeto FileReader
  const reader = new FileReader();

  // Adicionamos um evento para
  // escutar o Reader
  reader.addEventListener(
    "load",
    () => {
      //  Quando carregado,
      // reader.result retornará
      // o objeto convertido em Base64
      setNewPicture(reader.result);
    },
    false
  );

  // Caso file esteja populado
  // dispara a função.
  if (file) {
     reader.readAsDataURL(file);

  }
    };
    const transformImageToBase64Mobile = (e) => {
  // Selecionando o arquivo
  const file = e.target.files[0];

  setImageMobilePreview(file)

  // Criando um objeto FileReader
  const reader = new FileReader();

  // Adicionamos um evento para
  // escutar o Reader
  reader.addEventListener(
    "load",
    () => {
      //  Quando carregado,
      // reader.result retornará
      // o objeto convertido em Base64
      setImage(reader.result);
    },
    false
  );

  // Caso file esteja populado
  // dispara a função.
  if (file) {
     reader.readAsDataURL(file);

  }
    };


    const verifySetCitySelectUser = (e) =>{

      setCitySelectUser(e)
  
    }
    const setVerifyShowSelect = (e) =>{
  
      setShowSelect(true)
      setShowCityFromApi(false)
    }
    const dateFormated = () => {
    let dataFormated =  moment.utc(birthFromApi).format('DD/MM/YYYY')
    setBirthDateFormated(dataFormated)
    }

   
    /* UseEffects */


    useEffect(() => {

      dateFormated()
    })
    useEffect(() =>{
      verifyUser(responseVerifyUser)
      getInfoUser()
      getDataTransactions()
      getCitysFromuser()

    },[])
    

    return(

    <>

    <div className="container_partners">
    <Header change={changeHeader} imageUser={imageSeted} nameUserFromApi={name}/>

    <div className="row_container">
    <Sidebar checked="account"/>
    </div> {/* End row_container */}

    <div className="column_paymentCard">
    <div className="list_indications_profile">
    <div className="icon_indications_profile" onClick={verifyButton}>

    <input type="file" name="file" id="file"  onChange={(e) => transformImageToBase64Desktop(e)} style={{display:'none'}}/> 
   

    { button == true  && imageDesktop != null  ?     
    <>
    <img src={URL.createObjectURL(imageDesktop)} style={{width:'115px'}}/>
    <label  className="camera_icon" htmlFor="file" style={{marginTop:'80px',marginLeft:'65px'}}>
    <img src={cameraIcon} style={{width:'40px'}}/></label>

    </>
    :

    image == undefined 
    ?

    <>
    <img  src={userProfile}  className="image_user_profile"/>
    <label  className="camera_icon" htmlFor="file" style={{marginTop:'80px',marginLeft:'65px'}}>
    <img src={cameraIcon} style={{width:'40px'}}/></label>
    </>
    :
    <>
    <img  src={`data:image/;base64,${image}`}  className="image_user_profile"/>
    <label  className="camera_icon" htmlFor="file" style={{marginTop:'80px',marginLeft:'65px'}}>
    <img src={cameraIcon} style={{width:'40px'}}/></label>
    </>

    }
    
    </div> {/* End icon_indications_profile */}
 

    <h2  className="label_profile">Dados pessoais</h2>
    <div className="container_inputs_indications_profile">

    <div>
    <InputMasked  mask="999.999.999-99" value={cpfFromApi} onChange={(e) => setNewCpf(e.target.value)} className="input_indications_profile"/>
    <img src={digitalIcon} className="input_icon_indications"/>
    <label>CPF</label>
    </div>

    <div>
    <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input_indications_profile"/>
    <img src={userIcon} className="input_icon_indications"/>
    <label>Nome</label>
    {nameError != undefined ?<p className="error_desktop_profile">{nameError}</p> : ''}
    </div>


    <div>
    <InputMasked mask="(99) 99999-9999" disableUnderline  value={phone} onChange={(e) => setPhone(e.target.value)} className="input_indications_profile"/>

    <img src={phoneIcon} className="input_icon_indications"/>
    <label>Telefone</label>
    {phoneError != undefined ?<p className="error_desktop_profile">{phoneError}</p> : ''}

    </div>


    <div>
    <input type="text"  value={email} onChange={(e) => setEmail(e.target.value)} className="input_indications_profile"/>
    <img src={mailIcon} className="input_icon_indications"/>
    <label>Email</label>
    {emailError != undefined ?<p className="error_desktop_profile">{emailError}</p> : ''}

    </div>


    <div>

    <InputMasked mask="99/99/9999"  placeholder={birthFormated} value={birthDate} onChange={(e) => setBirthDate(e.target.value)} className="input_indications_profile"/>
    <img src={calendaIcon} className="input_icon_indications"/>
    <label>Data de nascimento</label>
    </div>



    <div>
    <input type="password" onChange={(e) => setNewPassword(e.target.value)} className="input_indications_profile"/>
    <img src={lockIcon} className="input_icon_indications"/>
    <label>Senha</label>
    </div>

    <div>
    <input type="password" onChange={(e) => setNewPassword2(e.target.value)} className="input_indications_profile"/>
    <img src={lockIcon} className="input_icon_indications"/>
    <label>Confirme sua Senha</label>
    </div>

    <div>

    </div>

    {passwordError != null ? <p style={{position:'relative',top:-35,color:'red'}}>{passwordError}</p> :''}

    <div>
    </div>
    </div> {/* End container_inputs_indications_profile */}

    <h2 className="label_profile">Dados bancários</h2>
    <div className="container_select_option_payment_profile">
    <div className="select_option_payment_profile">

    
    {pixState == 'none' 
    ?

    <>
    <div className="checked_payment_profile">
    <img src={bankIcon2}/>  
    <p>TED/DOC</p>
    </div>

    
    <div className="checked_payment_profile_not_background" onClick={() => verifyStatePix('pixSelect')}>
    <img src={pixIcon2}/>  
    <p>Pix</p>
    </div>
    </>

    :

    <>
    
    <div className="checked_payment_profile_ted_not_background" onClick={() => verifyStatePix('tedSelect')}>
    <img src={bankIcon2}/>  
    <p>TED/DOC</p>
    </div>

    <div className="checked_payment_profile">
    <img src={pixIcon2}/>  
    <p>Pix</p>
    </div>
    </>
    
    
    }

  
      
    </div> {/* End select_option_payment_profile */}
    </div> {/* End container_select_option_payment_profile */}

    <div className="container_inputs_indications_profile">
    {pixState == 'none' 
    ? 
  
    <>
    <div>
    <select  className="input_indications_profile_select" onChange={(e) => setBank(e.target.value)}>

    {nameBankFromApi == undefined 
    
    ?
  
    <option value="">Seu Banco</option>
    
    :
    <option value={codeBankFromApi}>{nameBankFromApi}</option>

    }

   {banks.map(item =>{
    return <option value={item.code}>{item.name}</option>
    })}


    </select>
    <label>Tipo Banco</label>
  
    </div>


    <div>
    <InputMasked mask="99999999999999" value={account}  placeholder={account} onChange={(e) => setAccount(e.target.value)} className="input_indications_profile"/>
    <label>Conta</label>
    </div>
     
    <div>
    <InputMasked mask="99999999999999"   value={agency} onChange={(e) => setAgency(e.target.value)} className="input_indications_profile"/>
    <label>Agência</label>
    </div>

    <div></div>

    </>
    :

    <div>
    <input type="text" placeholder='Seu pix' value={pix} onChange={(e) => setPix(e.target.value)} className="input_indications_profile"/>
    <img src={pixIcon} className="input_icon_indications_pix"/>
    </div>

    }

    </div> {/* End container_inputs_indications_profile */}

    <h2  className="label_profile">Endereço</h2>
    <div className="container_inputs_indications_profile">

    <div>
    <InputMasked  mask="99999-999" value={zip}  onChange={(e) => setZip(e.target.value)} onBlur={(e) => getCep(e)} className="input_indications_profile"/>
    <label>CEP</label>
    {zipError != undefined ?<p className="error_desktop_profile">{zipError}</p> : ''}

    </div>

    <div>
    <input type="text" value={address}   onChange={(e) => setAddress(e.target.value)} className="input_indications_profile"/>
    <label>Endereço</label>
    {addressError != undefined ?<p className="error_desktop_profile">{addressError}</p> : ''}

    </div>


    <div>
    <input type="text"  value={complement} onChange={(e) => setComplement(e.target.value)} className="input_indications_profile"/>
    <label>Complemento</label>
    {complementError != undefined ?<p className="error_desktop_profile">{complementError}</p> : ''}

    </div>


    <div>
    <input type="text"  value={neighboard}  onChange={(e) => setNeighboard(e.target.value)} className="input_indications_profile"/>
    <label>Bairro</label>
    {neighboardError != undefined ?<p className="error_desktop_profile">{neighboardError}</p> : ''}
    </div>


    <div>

  <select className="input_indications_profile_select" onClick={setVerifyShowSelect}  onChange={(e) => searchDataCitys(e.target.value)} >
      
    
    {stateFromViaCep != undefined 
    ?
    <option value={stateFromViaCep}>{stateFromViaCep}</option>
  
    :

    showSelect == false 
        
      ?
      
      <option value={codeState}>{codeState}</option>
  
      :
      <>
      <option value="AC">Acre</option>
      <option value="AL">Alagoas</option>
      <option value="AP">Amapá</option>
      <option value="AM">Amazonas</option>
      <option value="BA">Bahia</option>
      <option value="CE">Ceará</option>
      <option value="DF">Distrito Federal</option>
      <option value="ES">Espírito Santo</option>
      <option value="GO">Goiás</option>
      <option value="MA">Maranhão</option>
      <option value="MT">Mato Grosso</option>
      <option value="MS">Mato Grosso do Sul</option>
      <option value="MG">Minas Gerais</option>
      <option value="PA">Pará</option>
      <option value="PB">Paraíba</option>
      <option value="PR">Paraná</option>
      <option value="PE">Pernambuco</option>
      <option value="PI">Piauí</option>
      <option value="RJ">Rio de Janeiro</option>
      <option value="RN">Rio Grande do Norte</option>
      <option value="RS">Rio Grande do Sul</option>
      <option value="RO">Rondônia</option>
      <option value="RR">Roraima</option>
      <option value="SC">Santa Catarina</option>
      <option value="SP">São Paulo</option>
      <option value="SE">Sergipe</option>
      <option value="TO">Tocantins</option>
      <option value="EX">Estrangeiro</option>
      <option value="">Estado</option>
  
      </>
      
  
    }
      
    

  </select>

  <label>Estado </label>
  
  
    {stateError != undefined ?<p className="error_desktop_profile">{stateError}</p> : ''}

    </div>


    <div>

    <select className="input_indications_profile_select" onClick={() =>setShowCityFromApi(false)} onChange={(e) => verifySetCitySelectUser(e.target.value)} >
    
    {cityFromViaCep != undefined 
    
      ?
      <>
      <option value={stateFromViaCep}>{cityFromViaCep}</option>
      {citysArray0.map(item => {
        return <option   value={item.id} >{item.city}</option>
      })}
     </>

      
      :
      <>
      {
      showCityFromApi == false 
      ?
      stateCity == undefined ?
      
      <>
      
      {citysFromSelect.map(item => {
      <option value={cityFromApi}>{cityFromApi}</option>
      return <option   value={item.id} >{item.city}</option>
      })}
  
      </>
      :
      <>
      <option value=''>Selecione</option>
      {citysArray0.map(item => {
      return <option   value={item.id} >{item.city}</option>
      })}
  
      </>
        
      
      :
      <>
      <option value={cityFromApi.idCity}>{cityFromApi.nameCity}</option>
      </>
      }
      </>
      
     
      }
    
    

   
    

    </select>

    <label>Cidade </label>
    {cityError != undefined ?<p className="error_desktop_profile">{cityError}</p> : ''}

    </div>



    <div>

    </div>

    {passwordError != null ? <p style={{position:'relative',top:-35,color:'red'}}>{passwordError}</p> :''}

    <div>
    </div>
    </div> {/* End container_inputs_indications_profile */}

    <div className="btn_indications_input">
    <ButtonMobileGif className="save_data_profile_mobile" text="Salvar" gif={gif} onClick={changeData} />
    </div> {/* End btn_indications_input */}

    </div> {/* End list_indications_profile */}

  
    <div className="list_indications">
    <h2>Histórico de transação</h2>
    <table class="table table-borderless">
    <thead className="test">
    <tr className="test2">
    <th scope="col">Plano</th>
    <th scope="col">Data</th>
    <th scope="col">Valor</th>
    <th scope="col">Situação</th>
    </tr>
    </thead>
    <tbody>
    
    {dataPayment.map(item => {
    return <Transactions value={item.value} type={item.plan.type} situation={item.confirmation}/>
    })}
    </tbody>
    </table>
    </div> {/* End list_indications */}


    </div> {/* End column_paymentCard */}
    </div> {/* End container_partners */}


    {/*Mobile Layout */}


    <div className="profile_mobile">    
    <div className="header_profile_mobile">
    <img src={backIcon} onClick={() => window.location.href="/dashboard"}/>
    <h2>Minha Conta</h2>
    </div> {/* End header_profile_mobile */}

    <div className="container_inputs_profile_mobile">

        <div className="container_profile_user_mobile" onClick={verifyButton}>

        {button == true  && imageMobilePreview != null

        ?
        <>
        <label htmlFor='image'>  <img src={URL.createObjectURL(imageMobilePreview)} className="user_profile_mobile"/></label>
        <img src={cameraIcon } className="camera_icon_profile_mobile"/>
        </>
    
        :
        
        imageUserAPi != null  ? 
        <>
        <label htmlFor='image'><img src={`data:image/;base64,${image}`} className="user_profile_mobile"/></label>
        <img src={cameraIcon } className="camera_icon_profile_mobile"/>
        </>


        :
        <>
        <label htmlFor='image'><img src={userProfile} className="user_profile_mobile"/></label>
        <img src={cameraIcon } className="camera_icon_profile_mobile"/>
        </>
        }

      
        </div>



        <input type="file" name="image" id="image" onChange={(e) => transformImageToBase64Mobile(e)} />

        

        <p>Dados Pessoais</p>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile value={cpfFromApi} mask="999.999.999-99" className="input_profile_mobile"/>
        <img src={digitalIcon} className="icon_input_profile_mobile"/>
        </div>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile  value={name} type="text" onChange={(e) => setName(e.target.value)} className="input_profile_mobile"/>
        <img src={profileIcon} className="icon_input_profile_mobile"/>
        {nameError != undefined ?<p  style={{color:'red'}}>{nameError}</p> : ''}

        </div>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile  mask="(99) 99999-9999"   value={phone} type="tel" onChange={(e) => setPhone(e.target.value)} className="input_profile_mobile"/>
        <img src={phoneIcon} className="icon_input_profile_mobile"/>
        {phoneError != undefined ?<p  style={{color:'red'}}>{phoneError}</p> : ''}

        </div>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile  value={email} type="text" onChange={(e) => setEmail(e.target.value)} className="input_profile_mobile"/>
        <img src={mailIcon2} className="icon_input_profile_mobile"/>
        {emailError != undefined ?<p  style={{color:'red'}}>{emailError}</p> : ''}

        </div>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile placeholder={birthFormated} value={birthDate}  type="tel" mask="99/99/9999" onChange={(e) => setBirthDate(e.target.value)} className="input_profile_mobile"/>
        <img src={calendarIcon} className="icon_input_profile_mobile"/>
        </div>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile  placeholder="Nova Senha"  type="password" onChange={(e) => setNewPassword(e.target.value)} className="input_profile_mobile"/>
        <img src={lockIcon2} className="icon_input_profile_mobile"/>
        </div>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile  placeholder="Confirmação de senha"  type="password" onChange={(e) => setNewPassword2(e.target.value)} className="input_profile_mobile"/>
        <img src={lockIcon2} className="icon_input_profile_mobile"/>
        </div>

        {passwordError != null ? <h3 className="error_message_profile_mobile">{passwordError}</h3> : ''}


        <p>Dados bancários</p>

        <div className="select_bank_option_profile_mobile">

        

        {tedValue == 'none' 
        
        ?
        <>
        <div className="option_2_profile_mobile_not_Select" onClick={() => verifyState('Ted')}>
        <img src={bankIcon2}/>
        <p>TED/DOC</p>

        </div>



        <div className="option_1_profile_mobile"  onClick={() => verifyState('Pix') }>
        <img src={pixIcon}/>
        </div>
        
        </>

        :

        <>
        <div className="option_1_profile_mobile" onClick={() => verifyState('Ted')}>
        <img src={bankIcon2}/>
        <p>TED/DOC</p>

        </div>



        <div className="option_2_profile_mobile"  onClick={() => verifyState('Pix') }>
        <img src={pixIcon2}/>
        </div>
        
        </>
        }

   
        </div>





        {tedValue == 'none' ? 
        
        <div className='input_pix_profile_mobile'>
        <InputMaskedMobile  placeholder="Seu Pix" value={pix}  type="text" onChange={(e) => setPix(e.target.value)} className="input_profile_mobile2"/>
        </div>
        :
    

        <div className="select_option_1_profile_mobile" onChange={(e) => setCodBank(e.target.value)} style={{display:tedValue}}>
        <select>

        {nameBankFromApi == undefined 
    
          ?
        
          <option value={codeBankFromApi}>Seu Banco</option>
          
          :
          <option value={codeBankFromApi}>{nameBankFromApi}</option>

          }

        {banks.map(item =>{

            return <option value={item.code}>{item.name}</option>


          })}
        </select>
        
 

        <div className="flex_select_option_1_profile_mobile" >

        <InputMaskedMobile  placeholder="Sua conta" value={account} mask="9999999999999" type="tel" onChange={(e) => setAccount(e.target.value)} className="input_profile_mobile2"/>
        <InputMaskedMobile  placeholder="Sua Agência"  value={agency} mask="9999999999999" type="tel" onChange={(e) => setAgency(e.target.value)} className="input_profile_mobile2"/>
        </div>

        </div>

        }


        <p>Endereço</p>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile  placeholder={"CEP"} value={zip} onBlur={(e) => getCep(e)} onChange={(e) => setZip(e.target.value)} mask="99999-999"  className="input_profile_mobile"/>
        {zipError != undefined ?<p  style={{color:'red'}}>{zipError}</p> : ''}

        </div>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile  placeholder={"Endereço"} type="text"  value={address} onChange={(e) => setAddress(e.target.value)} className="input_profile_mobile"/>
        {addressError != undefined ?<p  style={{color:'red'}}>{addressError}</p> : ''}

        </div>

        <div className="input_column_profile_mobile">
        <InputMaskedMobile  placeholder={"Complemento"} value={complement} type="text" onChange={(e) => setComplement(e.target.value)} className="input_profile_mobile"/>
        {complementError != undefined ?<p  style={{color:'red'}}>{complementError}</p> : ''}

        </div>


        <div className="input_column_profile_mobile">
        <InputMaskedMobile  placeholder={"Bairro"} value={neighboard} type="text" onChange={(e) => setNeighboard(e.target.value)} className="input_profile_mobile"/>
        {neighboardError != undefined ?<p  style={{color:'red'}}>{neighboardError}</p> : ''}

        </div>

    

        <div className="input_column_profile_mobile" onClick={setVerifyShowSelect} onChange={(e) => searchDataCitys(e.target.value)} >
        <select   className="input_profile_mobile_select_2">
      
      
        {stateFromViaCep != undefined 
        ?
        <option value={stateFromViaCep}>{stateFromViaCep}</option>
      
        :

        showSelect == false 
            
          ?
          
          <option value={codeState}>{codeState}</option>
      
          :
          <>
          <option value="AC">Acre</option>
          <option value="AL">Alagoas</option>
          <option value="AP">Amapá</option>
          <option value="AM">Amazonas</option>
          <option value="BA">Bahia</option>
          <option value="CE">Ceará</option>
          <option value="DF">Distrito Federal</option>
          <option value="ES">Espírito Santo</option>
          <option value="GO">Goiás</option>
          <option value="MA">Maranhão</option>
          <option value="MT">Mato Grosso</option>
          <option value="MS">Mato Grosso do Sul</option>
          <option value="MG">Minas Gerais</option>
          <option value="PA">Pará</option>
          <option value="PB">Paraíba</option>
          <option value="PR">Paraná</option>
          <option value="PE">Pernambuco</option>
          <option value="PI">Piauí</option>
          <option value="RJ">Rio de Janeiro</option>
          <option value="RN">Rio Grande do Norte</option>
          <option value="RS">Rio Grande do Sul</option>
          <option value="RO">Rondônia</option>
          <option value="RR">Roraima</option>
          <option value="SC">Santa Catarina</option>
          <option value="SP">São Paulo</option>
          <option value="SE">Sergipe</option>
          <option value="TO">Tocantins</option>
          <option value="EX">Estrangeiro</option>
          <option value="">Estado</option>
      
          </>
          
      
        }

    

        </select>

        {stateError != undefined ?<p style={{color:'red'}}>{stateError}</p> : ''}

        </div>

       
        <div className="input_column_profile_mobile">
        <select className="input_profile_mobile_select_2" onClick={() =>setShowCityFromApi(false)} onChange={(e) => setCitySelectUser(e.target.value)}>
        
        {cityFromViaCep != undefined 
    
      ?
      <>
      <option value={stateFromViaCep}>{cityFromViaCep}</option>

      {citysArray0.map(item => {
        return <option   value={item.id} >{item.city}</option>
      })}
     </>

      
      :
      <>
      {
      showCityFromApi == false 
      ?
  
      stateCity == undefined ?
      
      <>
      {citysFromSelect.map(item => {
      <option value={cityFromApi}>{cityFromApi}</option>
      return <option   value={item.id} >{item.city}</option>
      })}
  
      </>
      :
      <>
      <option value=''>Selecione</option>
      {citysArray0.map(item => {
      return <option   value={item.id} >{item.city}</option>
      })}
  
      </>
        
      
      :
      <>
      <option value={cityFromApi.idCity}>{cityFromApi.nameCity}</option>
      </>
      }
      </>
      
     
      }
    

    
        </select>
        {cityError != undefined ?<p className="error_desktop_profile">{cityError}</p> : ''}

        </div>

        <div className="buttons_profile_mobile">

        <ButtonMobileGif className="save_data_profile_mobile" text="Salvar"   gif={gif}  onClick={changeDataMobile}  />
        <button className="exit_profile_mobile" onClick={exitApp}>Sair</button>

        </div>

    </div> {/* End container_inputs_profile_mobile */}

    </div> {/* End profile_mobile */}
    </>
      )
}

export default Profile
